import { useContext, useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/billing-buy-credits'
import Menu from '/components/billing/nav-menu'

import CreditsPriceList from '../components/billing/credits-price-list'
import CreditsBalance from '../components/billing/credits-balance'
import FreeCredits from '../components/billing/free-credits'
import CreditMatrix from '../components/billing/credit-matrix'

import { getCreditsBalance, getlastBundlePurchase } from '/providers/clients-api'

const BillingCongtractApplication = () => {

  const { apiSource, apiKey } = useContext(AppContext)

  const navigate = useNavigate()
  const { user } = useContext(AppContext)

  const [balance, setBalance] = useState()
  const [topupBundle, setTopupBundle] = useState(null)
  const [lastPurchase, setLastPurchase] = useState()

  useEffect(() => {
    getCredits()
    getLastPurchase()
  }, [])

  const refreshBalance = () => {
    getCredits()
    getLastPurchase()
  }

  const getCredits = async () => {
    const b = await getCreditsBalance({ apiSource, apiKey })
    setBalance(b.balance)
    setTopupBundle(b.topupBundle)
  }

  const getLastPurchase = async () => {
    const p = await getlastBundlePurchase({ apiSource, apiKey })
    setLastPurchase(p.bundle)
  }

  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing - Buy Credits" HelpText={HelpText} heading="Buy Credits" menu={<Menu />}>
      <div className='flex flex-row w-full justify-between'>
        <FreeCredits balance={balance} lastPurchase={lastPurchase}/>
        <CreditsBalance balance={balance} lastPurchase={lastPurchase} topupBundle={topupBundle}/>
        <CreditsPriceList refreshBalance={refreshBalance} balance={balance}/>
      </div>

      <div className='p-5'>
        <CreditMatrix />
      </div>
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingCongtractApplication
